import type { EBillingAccount } from "@/modules/billing/billingLogic.tsx";
import type { BoundCardMethod, BoundOtherMethod } from "@/modules/billing/BoundMethod.ts";
import { ConversionMessage } from "@/modules/billing/ConversionMessage.tsx";
import { CurrencyPaymentFees } from "@/modules/billing/CurrencyPaymentFees.tsx";
import { InvoicePaymentInfo } from "@/modules/billing/InvoicePaymentInfo.tsx";
import type { SiteAmount } from "@/modules/currency/currencyTypes.ts";
import { mcn, type BaseProps } from "@/utils/baseProps.ts";
import type { BillingAccountInvoice } from "@warrenio/api-spec/spec.oats.gen";

export function AllFees({
    billingAccount,
    amount,
    invoice,
    method,
    isInvoicePayment = false,
    ...props
}: {
    billingAccount: EBillingAccount;
    amount: SiteAmount;
    invoice?: BillingAccountInvoice;
    method?: BoundCardMethod | BoundOtherMethod | null;
    isInvoicePayment?: boolean;
} & BaseProps) {
    return (
        <div {...mcn("flex flex-col gap-2", props)}>
            {invoice && <InvoicePaymentInfo invoice={invoice} />}
            <CurrencyPaymentFees
                account={billingAccount}
                amount={amount}
                fees={method?.method.fee}
                isInvoicePayment={isInvoicePayment}
            />
            <ConversionMessage account={billingAccount} amount={amount} fees={method?.method.fee} card={method?.card} />
        </div>
    );
}
